import { render, staticRenderFns } from "./JournalEntryAddButton.vue?vue&type=template&id=1e23da9a"
import script from "./JournalEntryAddButton.vue?vue&type=script&lang=js"
export * from "./JournalEntryAddButton.vue?vue&type=script&lang=js"
import style0 from "./JournalEntryAddButton.vue?vue&type=style&index=0&id=1e23da9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports